import { Link } from "react-router-dom";
import { Mail, Phone, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative bg-black border-t border-white/10 text-zinc-400" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <div className="h-14 w-20 overflow-hidden flex items-start justify-center shrink-0">
              <img src="https://customer-assets.emergentagent.com/job_hybrid-dev-2/artifacts/2s3fmr01_Abstract%20Ridgeline%20with%20Circuit%20Line%20Motifs%283%29.png" alt="Ridgeline" className="w-20 h-20 object-contain" style={{ objectPosition: 'top', transform: 'scale(1.35)', transformOrigin: 'center 30%' }} />
            </div>
            <span className="font-display font-black tracking-tight text-white text-2xl">Ridgec<span className="text-[#ff3333]">X</span></span>
          </div>
          <p className="mt-5 text-sm text-zinc-400 max-w-md leading-relaxed">
            Ridgeline Cyber Services LLP — a hybrid software studio where senior engineers and AI build enterprise-grade applications, cybersecurity platforms and brands in weeks, not months.
          </p>
          <div className="mt-6 space-y-2 text-sm">
            <a href="mailto:reach@ridgecx.com" className="flex items-center gap-2 hover:text-white transition-colors" data-testid="footer-email">
              <Mail size={14} className="text-[#ff3333]" /> reach@ridgecx.com
            </a>
            <a href="tel:+918960999515" className="flex items-center gap-2 hover:text-white transition-colors" data-testid="footer-phone">
              <Phone size={14} className="text-[#ff3333]" /> +91-8960999515
            </a>
          </div>
        </div>

        <div className="md:col-span-2">
          <p className="overline mb-4">Company</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/services" className="hover:text-white">Services</Link></li>
            <li><Link to="/portfolio" className="hover:text-white">Work</Link></li>
            <li><Link to="/blog" className="hover:text-white">Insights</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="overline mb-4">Practices</p>
          <ul className="space-y-2 text-sm">
            <li>AI-Hybrid Development</li>
            <li>Enterprise Software</li>
            <li>Cybersecurity</li>
            <li>Brand & Marketing</li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="overline mb-4">Start</p>
          <Link to="/contact" className="btn-primary text-sm" data-testid="footer-cta">
            Book a 30-min call <ArrowUpRight size={16} />
          </Link>
          <p className="mt-1 text-xs text-zinc-600 mono">
            RIDGELINE CYBER SERVICES LLP · LUCKNOW · DELIVERING GLOBALLY
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 text-xs text-zinc-600 mono">
          <span>© {new Date().getFullYear()} Ridgeline Cyber Services LLP. All rights reserved.</span>
          <span>RIDGECX // v1.0 // BUILT AT VELOCITY</span>
        </div>
      </div>
    </footer>
  );
}
